import {
    SETTINGS_CHANGED,
    SETTINGS_SECTION_CHANGED,
    SETTINGS_SAVE_PENDING,
    SETTINGS_SAVE_SUCCESS,
    SETTINGS_SAVE_ERROR,
    SETTINGS_VALIDATE_EMAIL_PENDING,
    SETTINGS_VALIDATE_EMAIL_SUCCESS,
    SETTINGS_VALIDATE_EMAIL_ERROR,
    SETTINGS_EMAIL_CHANGED
} from '../constants/ActionTypes';

import {
    saveSettings as apiSaveSettings,
    validateEmail as apiValidateEmail,
    changeEmail as changeEmail,
    approveChangeEmail as approveChangeEmail
} from '../views/reactViews/ApiUtil';


const settingsChangedAction = (key, value) => (dispatch, getState) => {
    if (getState().settingsReducer.isLoading) {
        return;
    }
    dispatch({
        type: SETTINGS_CHANGED,
        key,
        value
    });
    dispatch(updateSetting());
};

const settingsSavePendingAction = () => ({
    type: SETTINGS_SAVE_PENDING
});

const settingsChangedEmailAction = (emailToChangeTo) => ({
    type: SETTINGS_EMAIL_CHANGED,
    emailToChangeTo
});

const settingsSaveSuccessAction = () => ({
    type: SETTINGS_SAVE_SUCCESS
});

const settingsSaveErrorAction = () => ({
    type: SETTINGS_SAVE_ERROR
});

const updateSetting = () => async(dispatch, getState) => {
    dispatch(settingsSavePendingAction());
    try {
        await apiSaveSettings({settings: getState().settingsReducer.settings});
    } catch (e) {
        dispatch(settingsSaveErrorAction());
    }
    dispatch(settingsSaveSuccessAction());
};

const validateEmailPendingAction = () => ({
    type: SETTINGS_VALIDATE_EMAIL_PENDING
});

const validateEmailSuccessAction = () => ({
    type: SETTINGS_VALIDATE_EMAIL_SUCCESS
});

const validateEmailErrorAction = () => ({
    type: SETTINGS_VALIDATE_EMAIL_ERROR
});

const validateEmail = (eventId) => async(dispatch) => {
    dispatch(validateEmailPendingAction());

    try {
        await apiValidateEmail({
            eventId
        });
        dispatch(validateEmailSuccessAction());
    } catch (e) {
        dispatch(validateEmailErrorAction());
    }
};

const settingsRequestToChangeEmail = () => async(dispatch, getState) => await changeEmail({
    emailToChangeTo: getState().settingsReducer.emailToChangeTo,
    eventId: getState().eventReducer.event.id
});

const settingsEmailChanged = (options = {}) => async(dispatch, getState) => {
    dispatch(settingsChangedEmailAction(options.emailToChangeTo));
};

const settingsApproveEmailChange = (options = {}) => async(dispatch, getState) => await approveChangeEmail(options);

export {
    validateEmail,
    settingsChangedAction,
    settingsEmailChanged,
    settingsRequestToChangeEmail,
    settingsApproveEmailChange
};
